var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content-admin" },
    [
      _c(
        "div",
        { staticClass: "page-head" },
        [
          _c("div", [
            _c("h2", [_vm._v(_vm._s(_vm.pageTitle))]),
            _c("p", [_vm._v("发布后的内容会显示在 PC、App 和 H5 工作台。")]),
          ]),
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  return _vm.$router.push("/announcement/list")
                },
              },
            },
            [_vm._v("返回公告管理")]
          ),
        ],
        1
      ),
      _vm.tab !== "ACCOUNTS"
        ? [
            _c(
              "div",
              { staticClass: "toolbar" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", icon: "el-icon-plus" },
                    on: { click: _vm.newArticle },
                  },
                  [
                    _vm._v(
                      "新增" +
                        _vm._s(
                          _vm.tab === "NEWS"
                            ? "资讯"
                            : _vm.tab === "TEMPLATE"
                            ? "标准资料模板"
                            : "制度"
                        )
                    ),
                  ]
                ),
              ],
              1
            ),
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
                attrs: { data: _vm.articles, border: "" },
              },
              [
                _c("el-table-column", {
                  attrs: { prop: "title", label: "标题", "min-width": "220" },
                }),
                _vm.tab === "NEWS"
                  ? _c("el-table-column", {
                      attrs: {
                        prop: "accountName",
                        label: "公众号",
                        width: "160",
                      },
                    })
                  : _vm._e(),
                _vm.tab !== "TEMPLATE"
                  ? _c("el-table-column", {
                      attrs: { label: "封面", width: "90" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                row.coverUrl
                                  ? _c("img", {
                                      staticClass: "thumb",
                                      attrs: { src: row.coverUrl, alt: "封面" },
                                    })
                                  : _vm._e(),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1477129467
                      ),
                    })
                  : _vm._e(),
                _vm.tab === "TEMPLATE"
                  ? _c("el-table-column", {
                      attrs: {
                        prop: "summary",
                        label: "说明",
                        "min-width": "220",
                        "show-overflow-tooltip": "",
                      },
                    })
                  : _vm._e(),
                _vm.tab === "TEMPLATE"
                  ? _c("el-table-column", {
                      attrs: { label: "模板文件", "min-width": "210" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c("span", { staticClass: "template-file" }, [
                                  _c(
                                    "b",
                                    {
                                      class:
                                        "file-badge " +
                                        _vm.fileBadge(row.templateFileName)
                                          .kind,
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.fileBadge(row.templateFileName)
                                            .text
                                        )
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "span",
                                    { attrs: { title: row.templateFileName } },
                                    [
                                      _vm._v(
                                        _vm._s(row.templateFileName || "未上传")
                                      ),
                                    ]
                                  ),
                                  Number(row.templateFileCount) > 1
                                    ? _c("em", [
                                        _vm._v(
                                          "等 " +
                                            _vm._s(row.templateFileCount) +
                                            " 个"
                                        ),
                                      ])
                                    : _vm._e(),
                                ]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1148806815
                      ),
                    })
                  : _vm._e(),
                _c("el-table-column", {
                  attrs: { label: "状态", width: "90" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _vm._v(
                              _vm._s(
                                row.status === "PUBLISHED" ? "已发布" : "草稿"
                              )
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    655712189
                  ),
                }),
                _c("el-table-column", {
                  attrs: { label: "可见范围", width: "130" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _vm._v(
                              _vm._s(
                                row.visibility === "SELECTED"
                                  ? "指定人员"
                                  : "全部人员"
                              )
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    3778582805
                  ),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "publishTime",
                    label: "发布时间",
                    width: "190",
                  },
                }),
                _c("el-table-column", {
                  attrs: { label: "操作", width: "210" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.viewArticle(row.id)
                                  },
                                },
                              },
                              [_vm._v("查看")]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.editArticle(row.id)
                                  },
                                },
                              },
                              [_vm._v("编辑")]
                            ),
                            _c(
                              "el-button",
                              {
                                staticClass: "danger",
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.removeArticle(row)
                                  },
                                },
                              },
                              [_vm._v("删除")]
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    303212758
                  ),
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "pager" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { disabled: _vm.page <= 1 },
                    on: {
                      click: function ($event) {
                        _vm.page--
                        _vm.loadArticles()
                      },
                    },
                  },
                  [_vm._v("上一页")]
                ),
                _c("span", [_vm._v("第 " + _vm._s(_vm.page) + " 页")]),
                _c(
                  "el-button",
                  {
                    attrs: { disabled: _vm.articles.length < 20 },
                    on: {
                      click: function ($event) {
                        _vm.page++
                        _vm.loadArticles()
                      },
                    },
                  },
                  [_vm._v("下一页")]
                ),
              ],
              1
            ),
          ]
        : [
            _c(
              "div",
              { staticClass: "toolbar" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", icon: "el-icon-plus" },
                    on: { click: _vm.newAccount },
                  },
                  [_vm._v("添加公众号")]
                ),
              ],
              1
            ),
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
                attrs: { data: _vm.accounts, border: "" },
              },
              [
                _c("el-table-column", {
                  attrs: { label: "头像", width: "80" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          row.avatarUrl
                            ? _c("img", {
                                staticClass: "avatar",
                                attrs: {
                                  src: row.avatarUrl,
                                  alt: "公众号头像",
                                },
                              })
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "name",
                    label: "公众号名称",
                    "min-width": "180",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "description",
                    label: "简介",
                    "min-width": "240",
                  },
                }),
                _c("el-table-column", {
                  attrs: { label: "操作", width: "160" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  _vm.accountForm = { ...row }
                                  _vm.accountDialog = true
                                },
                              },
                            },
                            [_vm._v("编辑")]
                          ),
                          _c(
                            "el-button",
                            {
                              staticClass: "danger",
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.removeAccount(row)
                                },
                              },
                            },
                            [_vm._v("删除")]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
      _c(
        "el-dialog",
        {
          attrs: {
            title: "内容详情",
            visible: _vm.previewDialog,
            width: "680px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.previewDialog = $event
            },
          },
        },
        [
          _vm.previewArticle
            ? [
                _c("h2", [_vm._v(_vm._s(_vm.previewArticle.title))]),
                _c("p", { staticClass: "article-meta" }, [
                  _vm._v(
                    _vm._s(
                      _vm.previewArticle.accountName ||
                        _vm.contentTypeName(_vm.previewArticle.type)
                    ) +
                      " · " +
                      _vm._s(
                        _vm.previewArticle.status === "PUBLISHED"
                          ? "已发布"
                          : "草稿"
                      ) +
                      " · " +
                      _vm._s(
                        _vm.previewArticle.publishTime ||
                          _vm.previewArticle.createdAt ||
                          ""
                      )
                  ),
                ]),
                _vm.previewArticle.coverUrl
                  ? _c("img", {
                      staticClass: "preview-cover",
                      attrs: { src: _vm.previewArticle.coverUrl, alt: "封面" },
                    })
                  : _vm._e(),
                _vm.previewArticle.summary
                  ? _c("p", { staticClass: "article-summary" }, [
                      _vm._v(_vm._s(_vm.previewArticle.summary)),
                    ])
                  : _vm._e(),
                _vm.previewArticle.bodyHtml
                  ? _c("div", {
                      staticClass: "article-rich-body",
                      domProps: {
                        innerHTML: _vm._s(_vm.previewArticle.bodyHtml),
                      },
                    })
                  : _c("pre", { staticClass: "article-body" }, [
                      _vm._v(_vm._s(_vm.previewArticle.body)),
                    ]),
                _vm.previewArticle.mediaList &&
                _vm.previewArticle.mediaList.length
                  ? _c(
                      "div",
                      { staticClass: "article-media" },
                      [
                        _vm._l(
                          _vm.previewArticle.mediaList.filter(
                            (file) => !file.inline
                          ),
                          function (item) {
                            return [
                              item.kind === "IMAGE"
                                ? _c("img", {
                                    key: item.id || item.url,
                                    attrs: { src: item.url, alt: item.name },
                                  })
                                : item.kind === "VIDEO"
                                ? _c("video", {
                                    key: item.id || item.url,
                                    attrs: {
                                      src: item.url,
                                      controls: "",
                                      preload: "metadata",
                                    },
                                  })
                                : _c("approval-attachment-list", {
                                    key: item.id || item.url,
                                    attrs: { files: [item] },
                                  }),
                            ]
                          }
                        ),
                      ],
                      2
                    )
                  : _vm._e(),
                _vm.previewArticle.sourceUrl
                  ? _c(
                      "a",
                      {
                        attrs: {
                          href: _vm.previewArticle.sourceUrl,
                          target: "_blank",
                          rel: "noopener noreferrer",
                        },
                      },
                      [_vm._v("查看原文")]
                    )
                  : _vm._e(),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.articleForm.id ? "编辑内容" : "新增内容",
            visible: _vm.articleDialog,
            width: "min(1000px, 96vw)",
            "before-close": _vm.closeArticle,
            "close-on-press-escape": false,
            "close-on-click-modal": false,
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.articleDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.articleForm, "label-width": "100px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "标题", required: "" } },
                [
                  _c("el-input", {
                    attrs: { maxlength: "200", "show-word-limit": "" },
                    model: {
                      value: _vm.articleForm.title,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.articleForm,
                          "title",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "articleForm.title",
                    },
                  }),
                ],
                1
              ),
              _vm.articleForm.type === "NEWS"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "公众号", required: "" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "请选择公众号" },
                          model: {
                            value: _vm.articleForm.accountId,
                            callback: function ($$v) {
                              _vm.$set(_vm.articleForm, "accountId", $$v)
                            },
                            expression: "articleForm.accountId",
                          },
                        },
                        _vm._l(_vm.accounts, function (a) {
                          return _c("el-option", {
                            key: a.id,
                            attrs: { label: a.name, value: a.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.articleForm.type !== "TEMPLATE"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "封面图片" } },
                    [
                      _vm.articleDialog
                        ? _c("workbench-image-upload", {
                            on: {
                              uploading: function ($event) {
                                _vm.coverUploading = $event
                              },
                            },
                            model: {
                              value: _vm.articleForm.coverUrl,
                              callback: function ($$v) {
                                _vm.$set(_vm.articleForm, "coverUrl", $$v)
                              },
                              expression: "articleForm.coverUrl",
                            },
                          })
                        : _vm._e(),
                      _c("el-input", {
                        attrs: {
                          placeholder: "可上传图片或填写 HTTPS 图片地址",
                        },
                        model: {
                          value: _vm.articleForm.coverUrl,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.articleForm,
                              "coverUrl",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "articleForm.coverUrl",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label:
                      _vm.articleForm.type === "TEMPLATE" ? "说明" : "摘要",
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 2,
                      maxlength: "500",
                      "show-word-limit": "",
                      placeholder:
                        _vm.articleForm.type === "TEMPLATE"
                          ? "选填：填写模板用途或使用说明"
                          : "",
                    },
                    model: {
                      value: _vm.articleForm.summary,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.articleForm,
                          "summary",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "articleForm.summary",
                    },
                  }),
                ],
                1
              ),
              _vm.articleForm.type !== "TEMPLATE"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "正文" } },
                    [
                      _vm.articleDialog
                        ? _c("workbench-rich-editor", {
                            ref: "richEditor",
                            attrs: {
                              "media-count": _vm.articleForm.mediaList.length,
                            },
                            on: {
                              uploaded: _vm.addInlineMedia,
                              uploading: function ($event) {
                                _vm.editorUploading = $event
                              },
                            },
                            model: {
                              value: _vm.articleForm.bodyHtml,
                              callback: function ($$v) {
                                _vm.$set(_vm.articleForm, "bodyHtml", $$v)
                              },
                              expression: "articleForm.bodyHtml",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label:
                      _vm.articleForm.type === "NEWS"
                        ? "图片/视频"
                        : _vm.articleForm.type === "TEMPLATE"
                        ? "模板文件"
                        : "文档附件",
                  },
                },
                [
                  _vm.articleDialog
                    ? _c("workbench-media-upload", {
                        ref: "mediaUpload",
                        attrs: { type: _vm.articleForm.type },
                        on: {
                          uploading: function ($event) {
                            _vm.attachmentUploading = $event
                          },
                        },
                        model: {
                          value: _vm.articleForm.mediaList,
                          callback: function ($$v) {
                            _vm.$set(_vm.articleForm, "mediaList", $$v)
                          },
                          expression: "articleForm.mediaList",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm.articleForm.type === "NEWS"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "原文链接" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "可选：微信公众号文章 HTTPS 链接",
                        },
                        model: {
                          value: _vm.articleForm.sourceUrl,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.articleForm,
                              "sourceUrl",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "articleForm.sourceUrl",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "可见范围", required: "" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.articleForm.visibility,
                        callback: function ($$v) {
                          _vm.$set(_vm.articleForm, "visibility", $$v)
                        },
                        expression: "articleForm.visibility",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "ALL" } }, [
                        _vm._v("全部人员可见"),
                      ]),
                      _c("el-radio", { attrs: { label: "SELECTED" } }, [
                        _vm._v("指定范围可见"),
                      ]),
                    ],
                    1
                  ),
                  _vm.articleForm.visibility === "SELECTED"
                    ? _c(
                        "div",
                        { staticClass: "audience-picker" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.$refs.audiencePicker.show(
                                    _vm.articleForm.receiveList
                                  )
                                },
                              },
                            },
                            [_vm._v("选择人员、部门或角色")]
                          ),
                          _c(
                            "div",
                            _vm._l(
                              _vm.articleForm.receiveList,
                              function (item, index) {
                                return _c(
                                  "el-tag",
                                  {
                                    key: item.type + ":" + item.id,
                                    attrs: { closable: "" },
                                    on: {
                                      close: function ($event) {
                                        return _vm.articleForm.receiveList.splice(
                                          index,
                                          1
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(item.name))]
                                )
                              }
                            ),
                            1
                          ),
                          _c("p", { staticClass: "audience-help" }, [
                            _vm._v(
                              "按保存时所选部门、角色的人员确定可见范围；修改后立即生效。"
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "状态" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.articleForm.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.articleForm, "status", $$v)
                        },
                        expression: "articleForm.status",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "DRAFT" } }, [
                        _vm._v("保存草稿"),
                      ]),
                      _c("el-radio", { attrs: { label: "PUBLISHED" } }, [
                        _vm._v("立即发布"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.closeArticle()
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    loading: _vm.saving,
                    disabled: _vm.uploading,
                  },
                  on: { click: _vm.saveArticle },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("org-picker", {
        ref: "audiencePicker",
        attrs: { title: "选择可见范围", multiple: true },
        on: {
          ok: function ($event) {
            _vm.articleForm.receiveList = $event
          },
        },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.accountForm.id ? "编辑公众号" : "添加公众号",
            visible: _vm.accountDialog,
            "before-close": _vm.closeAccount,
            "close-on-press-escape": false,
            width: "560px",
            "close-on-click-modal": false,
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.accountDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.accountForm, "label-width": "95px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "名称", required: "" } },
                [
                  _c("el-input", {
                    attrs: { maxlength: "100", "show-word-limit": "" },
                    model: {
                      value: _vm.accountForm.name,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.accountForm,
                          "name",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "accountForm.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "头像" } },
                [
                  _vm.accountDialog
                    ? _c("workbench-image-upload", {
                        on: {
                          uploading: function ($event) {
                            _vm.avatarUploading = $event
                          },
                        },
                        model: {
                          value: _vm.accountForm.avatarUrl,
                          callback: function ($$v) {
                            _vm.$set(_vm.accountForm, "avatarUrl", $$v)
                          },
                          expression: "accountForm.avatarUrl",
                        },
                      })
                    : _vm._e(),
                  _c("el-input", {
                    attrs: { placeholder: "可上传图片或填写 HTTPS 图片地址" },
                    model: {
                      value: _vm.accountForm.avatarUrl,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.accountForm,
                          "avatarUrl",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "accountForm.avatarUrl",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "简介" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      maxlength: "500",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.accountForm.description,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.accountForm,
                          "description",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "accountForm.description",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.closeAccount()
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    loading: _vm.saving,
                    disabled: _vm.avatarUploading,
                  },
                  on: { click: _vm.saveAccount },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }